module.exports = __webpack_public_path__ + "img/dot-success.5dc399e3.svg";